import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'nx-ng-ticket-category',
  templateUrl: './ticket-category.component.html',
  styleUrls: ['./ticket-category.component.scss'],
})
export class TicketCategoryComponent {
  @Input()
  title = '';
  @Input()
  description = '';
  @Input()
  mostPopular = false;
  @Output()
  clicked: EventEmitter<string> = new EventEmitter<string>();

   public get isMostPopular() {
    return this.mostPopular;
  }

  public handleClick(): void {
    this.clicked.emit(this.title);
  }
}
